const consulta_planejamento_matricula = {
  path: "/consulta-planejamento-matricula",
  redirect: "/consulta-planejamento-matricula",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Consulta de Estimativa de Matrícula",
  },
  children: [
    {
      path: "/consulta-planejamento-matricula",
      name: "consulta-planejamento-matricula",
      component: () =>
        import(
          "@/views/ConsultaPlanejamentoMatricula/ConsultaPlanejamentoMatricula.vue"
        ),
    },
  ],
};

export { consulta_planejamento_matricula };
